'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStorageAPIClient = exports.registerEventHandlers = exports.StorageApiFacade = exports.StorageEvents = undefined;

var _events = require('./events');

var StorageEvents = _interopRequireWildcard(_events);

var _StorageApiFacade = require('./StorageApiFacade');

var _StorageApiFacade2 = _interopRequireDefault(_StorageApiFacade);

var _FetchStorageAdapter = require('./FetchStorageAdapter');

var _FetchStorageAdapter2 = _interopRequireDefault(_FetchStorageAdapter);

var _LocalStorageAdapter = require('./LocalStorageAdapter');

var _LocalStorageAdapter2 = _interopRequireDefault(_LocalStorageAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * This module exports the interface of the Storage package
 * @module Storage
 */

exports.StorageEvents = StorageEvents;
exports.StorageApiFacade = _StorageApiFacade2.default;
var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers() {};

function storageAdapterProps(instanceProps, contextProps) {
  return {
    appId: instanceProps.appId,
    instanceId: instanceProps.instanceId,
    contextEntityType: contextProps.contextType,
    contextEntityId: contextProps.entityId
  };
}

/**
 * @method
 *
 * @param {AppEventEmitter} outgoingDispatcher
 * @param {AppEventEmitter} internalDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 *
 * @return {StorageApiFacade}
 */
var createStorageAPIClient = exports.createStorageAPIClient = function createStorageAPIClient(outgoingDispatcher, internalDispatcher, instanceProps, contextProps) {
  var props = storageAdapterProps(instanceProps, contextProps);
  var env = contextProps.getProperty('appsEnvironment');
  var adapter = contextProps.getProperty('appsStorageadapter');

  var storageAdapter = new _FetchStorageAdapter2.default();
  if (env === 'development') {
    if (adapter !== 'fetch') {
      storageAdapter = _LocalStorageAdapter2.default.fromGlobals();
    }
  }

  return new _StorageApiFacade2.default(outgoingDispatcher, internalDispatcher, storageAdapter, props);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/index.js
// module id = 66
// module chunks = 0